// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
const images = require.context('../images', true);
const imagePath = (name) => images(name, true);

import 'popper.js';
import 'bootstrap';
import tippy from 'tippy.js';

import Rails from "@rails/ujs";
import Turbolinks from "turbolinks";
import * as ActiveStorage from "@rails/activestorage";

// import "channels"
import 'core-js/stable';
import 'src/jquery_present'
import 'jquery-ujs';
import 'src/clickable';
import 'src/file_upload';
import 'src/tooltips';
import 'src/users';

// import "css"
import '../stylesheets/application.sass';
import 'bootstrap-icons/font/bootstrap-icons.css'

window.tippy = tippy;
